/**
 * Loan Application Page
 */
import * as React from "react";
import ContactForm from "../components/ContactForm";
import Header from "../../components/Header";
import "./styles.css";
import Footer from "../../components/Footer";
import loanBG from "../../../images/loan.png";

function LoanApplication() {
  return (
    <>
      <Header />
      <section className="main-banner">
        <img
          loading="lazy"
          src={loanBG}
          alt="Main Banner"
          className="banner-image"
        />
        <div className="banner-content">
          <h1 className="banner-title">Loan Application</h1>
          <p className="banner-description">Complete the form below to apply for a loan</p>
        </div>
      </section>
      <section className="loan-application-section">
        <ContactForm />
      </section>
      <Footer />
      <style>{`
        .main-banner {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 180px 0px 100px;
          color: rgba(255, 255, 255, 1);
          position: relative;
        }
        
        @media (max-width: 991px) {
          .main-banner {
            padding: 100px 20px 60px;
          }
        }
        
        .banner-image {
          position: absolute;
          height: 100%;
          width: 100%;
          object-fit: cover;
          z-index: -1;
        }
        
        .banner-content {
          position: relative;
          display: flex;
          flex-direction: column;
          gap: 16px;
          align-items: center;
          text-align: center;
        }
        
        .banner-title {
          font-size: 48px;
          font-weight: 700;
        }
        
        @media (max-width: 991px) {
          .banner-title {
            font-size: 40px;
          }
        }
        
        .banner-description {
          font-size: 20px;
          font-weight: 400;
          text-align: center;
          max-width: 700px;
        }
        
        .loan-application-section {
          background: var(
            --orbit-color-style-orbit-pry-blue-orbit-pry-blue-500-main,
            #00327e
          );
          padding: 60px 20px 100px;
        }
        
        @media (max-width: 991px) {
          .loan-application-section {
            padding: 40px 20px 60px;
          }
        }
      `}</style>
    </>
  );
}

export default LoanApplication;
